<!--
 * @Author: Axs <i@axs.email>
 * @Date: 2020-08-07 17:55:05
 * @LastEditors: Axs <i@axs.email>
 * @LastEditTime: 2021-06-21 17:53:55
 * @Description: 
 * @FilePath: /src/components/tabbar/index.vue
-->
<template>
    <div class="tabber component flex iphone-x-adaptation">
        <div class="tabbar-item"
             :class="{'select': index == tabbarSelect}"
             v-for="(item , index) in tabbarList"
             @click="pageJump(item)"
             :key="index">
            <img class="icon"
                 :src="index == tabbarSelect ? item.selectIcon :item.icon" />
            <p class="name">{{item.name}}</p>
        </div>
    </div>
</template>
<script>
    import { PAGE_MAIN_MY } from 'page';
    import { MAIN_TABBER_LIST } from 'constant';
    export default {
        data() {
            return {
                tabbarSelect: 0,
                tabbarList: MAIN_TABBER_LIST,
                isOpenBack: false
            }
        },
        props: ['route'],
        watch: {
            route() {
                this.setTabbar();
            }
        },
        computed: {
        },
        created() {
            if (this.$store.state.common.platformId) {
                this.tabbarList = MAIN_TABBER_LIST;
            }
            else {
                this.tabbarList = [...MAIN_TABBER_LIST, {
                    icon: require("@/assets/icons/icon-tabber-my.png"),
                    selectIcon: require("@/assets/icons/icon-tabber-my-on.png"),
                    name: '我的',
                    path: PAGE_MAIN_MY,
                }];
            }
            this.setTabbar();

        },
        methods: {
            setTabbar() {
                let selectRoute = this.selectRoute || this.$route.path;
                for (let i = 0; i < this.tabbarList.length; i++) {
                    const item = this.tabbarList[i];
                    if (item.path === selectRoute) {
                        this.tabbarSelect = i;
                        break;
                    }
                }
            },
            pageJump(item) {
                if (this.route != item.path) {
                    this.$util.pageJump({
                        path: item.path,
                        config: {
                            jumpType: 1,
                        }
                    })
                }
            },
        }
    }
</script>
<style lang="less" scoped>
    @import url('~@/lib/base.less');
    .tabber {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        height: @tabbarHeight;
        background: white;
        box-shadow: 0 .pxToRem(-5) [] .pxToRem(10) [] 0 rgba(0, 0, 0, 0.05);
        z-index: 100;
        .tabbar-item {
            position: relative;
            text-align: center;
            width: 100%;
            height: 100%;
            flex: 1;
            padding: .pxToRem(10px) [] 0 0 0;
            .icon {
                position: absolute;
                top: .pxToRem(10px) [];
                left: 50%;
                transform: translateX(-50%);
                width: .pxToRem(54px) [];
                height: .pxToRem(54px) [];
            }
            .name {
                position: absolute;
                top: .pxToRem(64px) [];
                font-size: .pxToRem(20px) [];
                color: rgba(0, 0, 0, 0.5);
                width: 100%;
            }
            &.select {
                .name {
                    color: #f7b500;
                }
            }
        }
    }
</style>
